export default __webpack_public_path__ + "static/media/YellowEllipse.22061464.svg";